module.exports = __webpack_public_path__ + "img/slider-1-scratch.db7d035e.png";